import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { RequestMessage } from '../../models/message.model';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagesHistoryService {
  private baseURL = environment.requestServiceURL + '/mail';
  private requestID!: number;
  private messages = new BehaviorSubject<RequestMessage[]>([]);
  constructor(private http: HttpClient) { }

  getMessages(requestID: number) {
    if (this.messages.value.length === 0 || this.requestID !== requestID) {
      this.requestID = requestID;
      this.getMessagesFromDB(requestID);
    }
    return this.messages.asObservable();
  }

  setMessage(message: RequestMessage[]) {
    return this.http.post(this.baseURL + '/history', message).pipe(tap(() => this.getMessagesFromDB(this.requestID)));
  }

  resetMessages() {
    this.messages.next([]);
  }

  private getMessagesFromDB(requestID: number) {
    this.http.get<RequestMessage[]>(this.baseURL + '/history', { params: { requestId: requestID } })
      .subscribe((requestMessages) => this.messages.next(requestMessages));
  }
}
